import EventEmitter from 'events';
export const installationServiceSelectedEvent = 'installationServiceSelected';
export const InstallationServicesEmitter = new EventEmitter();
//# sourceMappingURL=Emitter.js.map